import React from "react";
import DataTable from "@/components/DataTable";
import { TRACKERS } from "@/config/trackers";

export function TrackerTable({ id }) {
  const cfg = TRACKERS[id];
  return <DataTable title={cfg.title} endpoint={cfg.endpoint} columns={cfg.columns} />;
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex items-start justify-between mb-6">
      <div>
        <h1 className="font-heading text-3xl font-extrabold">{title}</h1>
        {subtitle && <p className="text-slatetext mt-1">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function Tabs({ tabs, active, onChange }) {
  return (
    <div className="flex gap-1 mb-6 border-b border-surface-hover">
      {tabs.map((t) => (
        <button
          key={t.id}
          data-testid={`tab-${t.id}`}
          onClick={() => onChange(t.id)}
          className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors duration-200 ${
            active === t.id ? "border-gold text-gold" : "border-transparent text-slatetext hover:text-white"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
